// Тип действия для запроса заказа
export const FETCH_ORDER: 'FETCH_ORDER' = 'FETCH_ORDER';
// Тип действия для успешного завершения запроса заказа
export const FETCH_ORDER_SUCCESS: 'FETCH_ORDER_SUCCESS' = 'FETCH_ORDER_SUCCESS';
// Тип действия для неудачного завершения запроса заказа
export const FETCH_ORDER_FAILED: 'FETCH_ORDER_FAILED' = 'FETCH_ORDER_FAILED';
